// import { StatusDiv } from "components/Dashboard/Home/RecentApplications/style"
// import { ByshelbP } from "globalStyles"



export const REJCOLUMNS = [
		{
			title: "First Name",
			render: (originalRow) => <p>{originalRow?.applicant?.first_name + " " +  originalRow?.applicant?.surname}</p>
		},
		{
			title: "NIN",
			render: (originalRow) => <p>{originalRow?.applicant?.nin || "N/A"}</p>
	},
	{
			title: "LGA",
			render: (originalRow) => <p>{originalRow?.applicant?.lga}</p>
		},
		{
			title: "Institution",
			render: (originalRow) => <div style={{ maxWidth: "250px" }}>{originalRow?.institution?.name}</div>
		},
		{
			title: "Amount",
			render: (originalRow) => <p>₦{originalRow?.amount.toLocaleString()}</p>
		},
		{
			title: "Loan Type",
			dataIndex: "loan_type"
		},
		{
			title: "Rejected By",
			render: (originalRow) => <p>{originalRow?.rejectedBy}</p>
		},
		{
			title: "Rejection Reason",
			render: (originalRow) => <p>{originalRow?.comment}</p>
		},
]
